/**
 * Storage and wire-format helpers for a code-redemption guest's session token.
 * Token strings reach the API clients as bare strings with no indication of where
 * they came from, so `GUEST_TOKEN_PREFIX` is the marker `useSessionToken` and those
 * clients agree on to route a token to `X-Assessment-Session-Token` rather than
 * `Authorization`.
 */

export const GUEST_SESSION_TOKEN_KEY = 'evaltick_guest_session_token';

/** Prefixes a raw guest JWT so API clients can tell it apart from a Clerk token — see module doc. */
export const GUEST_TOKEN_PREFIX = 'guest:';

export const getStoredGuestSessionToken = (): string | null =>
  localStorage.getItem(GUEST_SESSION_TOKEN_KEY);

export const setStoredGuestSessionToken = (token: string): void => {
  localStorage.setItem(GUEST_SESSION_TOKEN_KEY, token);
};

export const clearStoredGuestSessionToken = (): void => {
  localStorage.removeItem(GUEST_SESSION_TOKEN_KEY);
};

export const isGuestToken = (token: string): boolean => token.startsWith(GUEST_TOKEN_PREFIX);

export const toGuestToken = (rawToken: string): string => `${GUEST_TOKEN_PREFIX}${rawToken}`;

export const stripGuestTokenPrefix = (token: string): string => token.slice(GUEST_TOKEN_PREFIX.length);
